module.exports = __webpack_public_path__ + "public/images/calendar-waiting.9cf5c1225649209c1243acab7538fe79.svg";